export default __webpack_public_path__ + "13.e3ea05.svg";